exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkr-grid-height {\n  height: 68vh; }\n\n.checkr-buttons-approve-rejected {\n  display: inline-block;\n  margin-right: 10px;\n  padding: 5px 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/administration/fleet/background-checks/background-checks.component.scss
// module id = 1941
// module chunks = 66